import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-55069e32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popularAccountsBox" }
const _hoisted_2 = { class: "mt-10" }
const _hoisted_3 = { class: "anchor-tag four-a-color" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"4px","padding-right":"4px","color":"#aaa"} }, " | ", -1))
const _hoisted_5 = { class: "table table-condensed pa-table" }
const _hoisted_6 = { class: "popular-account-head" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Account Type", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Account Name", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Min to Earn", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Max", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clearfix" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_how_da_gets_paid = _resolveComponent("how-da-gets-paid")!
  const _component_ad_disclosure_tooltip = _resolveComponent("ad-disclosure-tooltip")!
  const _component_apy_label = _resolveComponent("apy-label")!
  const _component_popular_account = _resolveComponent("popular-account")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("a", {
      href: "#rates",
      class: "pull-right view-all-link"
    }, "View all " + _toDisplayString(_ctx.bank.Name) + " accounts »", 513), [
      [_vShow, !_ctx.isBankNameLong]
    ]),
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_how_da_gets_paid),
      _createTextVNode(),
      _hoisted_4,
      _createTextVNode(),
      _createVNode(_component_ad_disclosure_tooltip)
    ]),
    _createElementVNode("table", _hoisted_5, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("th", null, [
            _createVNode(_component_apy_label)
          ]),
          _hoisted_8,
          _hoisted_9,
          _hoisted_10,
          _hoisted_11
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ads, (ad) => {
          return (_openBlock(), _createBlock(_component_popular_account, {
            key: ad.id,
            ad: ad
          }, null, 8, ["ad"]))
        }), 128))
      ])
    ]),
    _withDirectives(_createElementVNode("a", {
      href: "#rates",
      class: "pull-right view-all-link-long-name"
    }, "View all " + _toDisplayString(_ctx.bank.Name) + " accounts »", 513), [
      [_vShow, _ctx.isBankNameLong]
    ]),
    _hoisted_12
  ]))
}